import { createStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";

const styles = (theme: Theme) =>
  createStyles({
    mainContainer: {
      width: "100%",
    },
    fixedContainer: {
      position: "absolute",
      top: "0",
      zIndex: 1,
      backgroundColor: "transparent",
      [theme.breakpoints.down("sm")]: {
        position: "relative",
        backgroundColor: "white",
      },
    },
  });

export default styles;
